module.exports = __webpack_public_path__ + "img/map.f029d139.svg";